import { TableColumnWidthInfo } from "@devexpress/dx-react-grid";

export const tableColumnExtensionDiscrepancyComments: any[] =
  [
    { columnName: 'isInternal', wordWrapEnabled: true },
    { columnName: 'date', wordWrapEnabled: true },
    { columnName: 'comment', wordWrapEnabled: true },
    { columnName: 'title', wordWrapEnabled: true },
  ];

export const columnVisibilityActivityLog: string[] =
  [
    "newDateValue", "oldDateValue"
  ];

export const columnWidthDocumentList: TableColumnWidthInfo[] = [
  { columnName: 'isInternal', width: 100 },
  { columnName: 'fileExtension', width: 80 },
  { columnName: 'title', width: 180 },
  { columnName: 'createdDate', width: 180 },
  { columnName: 'description', width: 500 },
  { columnName: 'owner', width: 180 },
  { columnName: 'name', width: 180 }
]

export const columnWidtDiscrepancyComments: TableColumnWidthInfo[] = [
  { columnName: 'isInternal', width: 100 },
  { columnName: 'date', width: 200 },
  { columnName: 'comment', width: 500 },
  { columnName: 'name', width: 250 }
]

export const columnWidthActivityLog: TableColumnWidthInfo[] = [
  { columnName: 'orderStatus', width: 110 },
  { columnName: 'orderExternalId', width: 110 },
  { columnName: 'orderName', width: 140 },
  { columnName: 'description', width: 320 },
  { columnName: 'date', width: 140 }
]

// Discrepancies

export const discrepancyStatusNew = "#03A9F4";

export const discrepancyStatusRequestAction = "#FF9800";

export const discrepancyStatusRequestQuote = "#FFE0B2";

export const discrepancyStatusClosed = "#E0E0E0";

export const discrepancyStatusNextService = "#4CAF50";

export const mobileSizeSwitch = 600;

export const columnVisibilityDiscrepancy: string[] =
  [
    'externalId'
  ];

export const columnWidthDiscrepancyList: TableColumnWidthInfo[] = [
  { columnName: 'id', width: 100 },
  { columnName: 'status', width: 140 },
  { columnName: 'date', width: 200 },
  { columnName: 'externalId', width: 200 },
  { columnName: 'title', width: 200 },
  { columnName: 'discrepancyTypeName', width: 150 },
  { columnName: 'discrepancyStatus', width: 100 },
  { columnName: 'assetName', width: 100 },
  { columnName: 'origin', width: 100 },
  { columnName: 'performedBy', width: 100 },
  { columnName: 'originOrderId', width: 100 },
  { columnName: 'originOrderExternalId', width: 150 },
  { columnName: 'originOrderName', width: 150 },
  { columnName: 'requestForClosing', width: 130 },
  { columnName: 'requestedAction', width: 150 },
  { columnName: 'nextServiceDate', width: 100 },
  { columnName: 'classificationName', width: 150 },
  { columnName: 'departmentName', width: 150 },
  { columnName: 'departmentId', width: 150 },
  { columnName: 'severity', width: 200 },
  { columnName: 'customerName', width: 150 },
  { columnName: 'customerId', width: 150 }
];

export const tableColumnExtensionDiscrepancy: any[] =
  [
    { columnName: 'id', align: 'left', wordWrapEnabled: true },
    { columnName: 'status', align: 'left', wordWrapEnabled: true },
    { columnName: 'date', align: 'left', wordWrapEnabled: true },
    { columnName: 'externalId', align: 'left', wordWrapEnabled: true },
    { columnName: 'title', align: 'left', wordWrapEnabled: true },
    { columnName: 'discrepancyTypeName', align: 'left', wordWrapEnabled: true },
    { columnName: 'discrepancyStatus', align: 'left', wordWrapEnabled: true },
    { columnName: 'assetName', align: 'left', wordWrapEnabled: true },
    { columnName: 'origin', align: 'left', wordWrapEnabled: true },
    { columnName: 'performedBy', align: 'left', wordWrapEnabled: true },
    { columnName: 'originOrderId', align: 'left', wordWrapEnabled: true },
    { columnName: 'originOrderExternalId', align: 'left', wordWrapEnabled: true },
    { columnName: 'requestForClosing', align: 'center', wordWrapEnabled: true },
    { columnName: 'requestedAction', align: 'center', wordWrapEnabled: true },
    { columnName: 'nextServiceDate', align: 'left', wordWrapEnabled: true },
    { columnName: 'originOrderName', align: 'left', wordWrapEnabled: true },
    { columnName: 'classificationName', align: 'left', wordWrapEnabled: true },
    { columnName: 'departmentName', align: 'left', wordWrapEnabled: true },
    { columnName: 'departmentId', align: 'left', wordWrapEnabled: true },
    { columnName: 'severity', align: 'left', wordWrapEnabled: true },
    { columnName: 'customerId', align: 'left', wordWrapEnabled: true },
    { columnName: 'customerName', align: 'left', wordWrapEnabled: true }
  ]

export const emailTemplateTypeIdToName = (id: number) => {
  //TODO: Localization one day soon coming
  switch (id) {
    case 0:
      return 'User Creation Template';
    case 1:
      return 'User Backend Assignment Added Template';
    case 2:
      return 'Customer Portal Invite Template';
    case 3:
      return 'WebOffice Invite Template';
    case 4:
      return 'Forgotten Password Template';
    default:
      return 'User Creation Template';
  }
};